import React, { useState, useContext } from "react";
import "../style/login.css";
import Spinner from "./Spinner";
import api_url from "../constants";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

function Login() {
  const [userContext, setUserContext] = useContext(AuthContext);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [err, setError] = useState("");

  const login = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError("Please enter both username and password");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const response = await axios.post(
        `${api_url}/auth/managerLogin`,
        { username, password },
        {
          withCredentials: true,
          headers: { "Content-Type": "application/json" },
        }
      );
      if (response.data.success) {
        const data = response.data;
        setUserContext((oldValues) => ({ ...oldValues, token: data.token }));
      } else {
        setError(response.data.err);
      }
    } catch (error) {
      setError(
        error.response?.data?.err ? error.response.data.err : "Incorrect Password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" 
    style={{
    background: "linear-gradient(135deg, #2c3e50 0%, #16a085 100%)",
    minHeight: "100vh",
    width: "100%",
    margin: 0,
    padding: 0,
    display: "flex",
    flexDirection: "column"
}}>
      <form className="login-form-card" onSubmit={login}>
        <div className="login-header">
          <h3>Manager Access</h3>
          <span>Sign in to your dashboard</span>
        </div>
        
        <div className="login-body">
          {err && <div className="error-message">{err}</div>}

          <div className="input-group">
            <label>Username</label>
            <input
              type="text"
              className="login-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
            />
          </div>

          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              className="login-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
            />
          </div>

          <button className="login-submit-btn" type="submit" disabled={isLoading}>
            {isLoading ? <Spinner color="#fff" size={20} /> : "LOGIN"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default Login;